import React from 'react';
import { services } from '../data/mock';
import { 
  Stethoscope, 
  Shield, 
  Activity, 
  Heart, 
  Calendar, 
  Phone, 
  Users, 
  Briefcase,
  ArrowRight 
} from 'lucide-react';

const iconMap = {
  Stethoscope,
  Shield,
  Activity,
  Heart,
  Calendar,
  Phone,
  Users,
  Briefcase
};

const Services = () => {
  return (
    <section id="services" className="section-padding bg-[#f8f7f2]">
      <div className="container-custom">
        {/* Section header */}
        <div className="max-w-3xl mb-16">
          <div className="gold-accent mb-6"></div>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2d2d2d] mb-6">
            Comprehensive Medical Services
          </h2>
          <p className="text-[#5a5a5a] text-lg leading-relaxed">
            From preventative care to chronic disease management, we offer a full 
            spectrum of primary care services delivered with the time and attention 
            your health deserves.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Stethoscope;
            return (
              <div
                key={service.id}
                className="bg-[#fffef8] p-8 card-hover group"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-12 h-12 bg-[#f8f7f2] flex items-center justify-center mb-6 group-hover:bg-[#1a1a1a] transition-colors duration-300">
                  <IconComponent 
                    size={24} 
                    className="text-[#c9a962] group-hover:text-[#c9a962] transition-colors duration-300" 
                  />
                </div>
                <h3 className="font-serif text-xl text-[#2d2d2d] mb-3">
                  {service.title}
                </h3>
                <p className="text-[#8a8a8a] text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-[#5a5a5a] mb-6">
            Ready to experience healthcare the way it should be?
          </p>
          <a href="#contact" className="btn-primary inline-flex">
            Schedule Your Consultation
            <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
